import type { ReactNode } from "react";
import { cn } from "@/utils/ui";

/**
 * Viewfinder corner brackets: Chitravan's one decorative motif.
 * Use it only to say "this is the chosen one" (selected story, active cast member).
 */
export function FrameCorners({
	active,
	className,
	children,
}: {
	active?: boolean;
	className?: string;
	children: ReactNode;
}) {
	const corner = cn(
		"pointer-events-none absolute size-3 border-primary transition-opacity",
		active ? "opacity-100" : "opacity-0",
	);
	return (
		<div className={cn("relative", className)}>
			<span aria-hidden className={cn(corner, "-left-px -top-px border-l-2 border-t-2 rounded-tl-md")} />
			<span aria-hidden className={cn(corner, "-right-px -top-px border-r-2 border-t-2 rounded-tr-md")} />
			<span aria-hidden className={cn(corner, "-bottom-px -left-px border-b-2 border-l-2 rounded-bl-md")} />
			<span aria-hidden className={cn(corner, "-bottom-px -right-px border-b-2 border-r-2 rounded-br-md")} />
			{children}
		</div>
	);
}
